import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "..";
import styles from "./style.module.scss";
import "./style.scss";

const PrivacyAndTerms = ({ params }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={`${styles.privacyAndTerms} privacy-and-terms`}>
      <div className={styles.banner}>
        <Image src={params?.src} alt="banner" preview={false} />
      </div>
      <div className={styles.title}>{t(params?.title)}</div>
      <div className={styles.content} dangerouslySetInnerHTML={{ __html: t(params?.content) }} />
      <CustomButton buttonStyle={`${styles.customButtonStyle}`} onClick={() => navigate("/")}>
        {t("normal.accept")}
      </CustomButton>
    </div>
  );
};

export default PrivacyAndTerms;
